interface TimerDescriptionInputProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  placeholder?: string
}

export function TimerDescriptionInput({
  value,
  onChange,
  disabled = false,
  placeholder = "What are you working on?",
}: TimerDescriptionInputProps) {
  return (
    <div className="space-y-1.5">
      <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Description</label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        className="block w-full rounded-lg border border-input bg-background px-3 py-2.5 text-sm placeholder:text-muted-foreground/60 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all duration-200"
        data-testid="description-input"
      />
    </div>
  )
}

export default TimerDescriptionInput
